import server from "./server";

export const getContactsApi = async () => {
  const response = await server().get("/contactUs");
  return response.data;
};

export const getSingleContactApi = async (id) => {
  const response = await server().get(`/contactUs/${id}`);
  return response.data;
};

export const deleteContactApi = async ({ id }) => {
  const response = await server().delete(`/contactUs/${id}`);
  return response.data;
};
